import classes from '../MyCampaigns.module.scss'

import { TableCell, TableRow } from '@percent/lemonade'
import { TruncatedList } from '@percent/domain/giving'
import type { GivingCampaignPartnerDto } from '@percent/workplace-giving/api/campaigns/campaign.types'
import { useDateTimeFmt } from '@percent/workplace-giving/common/hooks'
import { StatusBadge } from './StatusBadge'
import { TitleLink } from './TitleLink'
import { ActionsMenu } from './ActionsMenu/ActionsMenu'

export type MyCampaignsTableRowProps = Readonly<{
  campaign: GivingCampaignPartnerDto
}>

export function MyCampaignsTableRow({ campaign }: MyCampaignsTableRowProps) {
  const { formatDateRange } = useDateTimeFmt()

  const formattedDates =
    campaign.startDate && campaign.endDate
      ? formatDateRange(new Date(campaign.startDate), new Date(campaign.endDate))
      : null

  return (
    <TableRow key={campaign.id}>
      <TableCell>
        <div className={classes.Name}>
          <TitleLink campaignHref={`/campaigns/${campaign.id}`} campaignTitle={campaign.title} />
        </div>
      </TableCell>
      <TableCell>{formattedDates ?? '—'}</TableCell>
      <TableCell>
        <TruncatedList items={campaign.groups.map(g => g.name)} />
      </TableCell>
      <TableCell>
        <StatusBadge campaign={campaign} />
      </TableCell>
      <TableCell>
        <ActionsMenu campaign={campaign} />
      </TableCell>
    </TableRow>
  )
}
